import { render, staticRenderFns } from "./create-or-edit-column-info.vue?vue&type=template&id=027a846c&scoped=true"
import script from "./create-or-edit-column-info.vue?vue&type=script&lang=js"
export * from "./create-or-edit-column-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027a846c",
  null
  
)

export default component.exports